/**
 * NovaLayoutRoute: no chrome, but behind fb-nova's own sign-in. Nova draws its own page (orb, icons, side card), so the
 * shell is the outlet. Someone who is not signed in is sent to the login page and returned here afterwards.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks';

export function NovaLayoutRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const here = useLocation();
  if (isLoading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Loader2 className="h-5 w-5 animate-spin" aria-label="Loading" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to={`/auth/login?next=${encodeURIComponent(here.pathname)}`} replace />;
  return <Outlet />;
}
